import React from 'react';
export default function PatchBackArtwork({image}:{image?:string}){
 return image?<img src={image} alt="" className="w-full h-full object-contain"/>:<svg viewBox="0 0 200 260" aria-hidden="true" className="w-full h-full text-[#9c9987]">
  <path d="M20 100a80 80 0 0 1 160 0v134q0 16-16 16H36q-16 0-16-16Z" fill="#e4e0d2" stroke="currentColor" strokeWidth="3"/>
  <path d="M29 100a71 71 0 0 1 142 0v130q0 11-11 11H40q-11 0-11-11Z" fill="none" stroke="currentColor" strokeWidth="2" strokeDasharray="2 5"/>
 </svg>;
}
